/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {McpServiceAccount} from '../models/McpServiceAccount';

export interface UpdateAccountMcpServiceAccount$Request {
    accountId: number;
    mcpServiceAccount: McpServiceAccount;
}

export interface UpdateAccountMcpServiceAccount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAccountMcpServiceAccountRequest = createAction<PayloadData<void, UpdateAccountMcpServiceAccount$Request>>('UPDATE_ACCOUNT_MCP_SERVICE_ACCOUNT__UPDATE_ACCOUNT_MCP_SERVICE_ACCOUNT__REQUEST');
export const updateAccountMcpServiceAccountSuccess = createAction<PayloadData<void, UpdateAccountMcpServiceAccount$Request>>('UPDATE_ACCOUNT_MCP_SERVICE_ACCOUNT__UPDATE_ACCOUNT_MCP_SERVICE_ACCOUNT__SUCCESS');
export const updateAccountMcpServiceAccountFailure = createAction<PayloadData<Error, UpdateAccountMcpServiceAccount$Request, true>>('UPDATE_ACCOUNT_MCP_SERVICE_ACCOUNT__UPDATE_ACCOUNT_MCP_SERVICE_ACCOUNT__FAILURE');

export const updateAccountMcpServiceAccountActions = [
    updateAccountMcpServiceAccountRequest,
    updateAccountMcpServiceAccountSuccess,
    updateAccountMcpServiceAccountFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {McpServiceAccount} meta.mcpServiceAccount
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAccountMcpServiceAccount = (meta: UpdateAccountMcpServiceAccount$Request, config?: UpdateAccountMcpServiceAccount$Config) => {
    return {
        CALL_API: {
            types: updateAccountMcpServiceAccountActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/mcp/settings`,
            TRANSPORT_REQUEST_BODY: meta.mcpServiceAccount,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

